import ExitImg from "../../assets/images/cms/exit-game-img.svg";
import { useTranslation } from "react-i18next";
import SecondaryBtn from "../button/SecondaryBtn";
import PrimaryBtn from "../button/PrimaryBtn";

const ExitGameModal = ({ isOpen, onClose, handleExitGame, isLoading }) => {
  const { t } = useTranslation();
  if (!isOpen) return null;
  return (
    <>
      <div className="fixed inset-0 bg-black/80 flex items-center justify-center lg:p-[1%] p-4 z-50">
        <div className="modal bg-white-500 2xl:rounded-[2.083vw] rounded-[40px] 2xl:p-[2.083vw] lg:p-10 md:p-7 p-4 2xl:max-w-[26.04vw] max-w-[500px] w-full relative animate-[slideUp_0.3s_ease-out] lg:border-[0.2vw] border-3 border-primary auth-page overflow-auto lg:max-h-[calc(100dvh-11%)] max-h-[calc(100dvh-40px)] hide-scroll">
          {/* Header */}
          <div className="text-center">
            <img
              src={ExitImg}
              alt=""
              className="w-auto mx-auto 2xl:h-[7.29vw] md:h-36 h-20 landscape:max-lg:h-20  2xl:mb-[1.50vw] md:mb-[30px] mb-3 landscape:max-lg:mb-3 rtl:-scale-x-100"
            />
            <h1 className="2xl:text-[1.5625vw]/[1.7vw] xl:text-3xl/6 text-2xl/6 font-bold text-primary-orange 2xl:mb-[0.42vw] md:mb-2 mb-1 landscape:max-lg:mb-1">
              {t("exitGameModal.exitGame")}
            </h1>
            <p className="2xl:text-[1.041vw]/[1.15vw] md:text-xl/tight text-base/tight landscape:max-lg:text-base/tight text-black-800 text-center font-bold">
              {t("exitGameModal.areYouSureYouWantToExitTheGame")}
            </p>
            <div className="flex xs:flex-row flex-col 2xl:gap-[1vw] gap-2 justify-center w-full 2xl:mt-[1.67vw] xl:mt-8 md:mt-5mt-4 landscape:max-lg:mt-4">
              <SecondaryBtn onClick={onClose} to="" className="xs:w-1/2 max-w-full lg:mb-0 md:mb-0 mb-0">
                {t("exitGameModal.continuePlaying")}
              </SecondaryBtn>
              <PrimaryBtn onClick={handleExitGame} className="xs:w-1/2 max-w-full lg:mb-0 md:mb-0 mb-0" isLoading={isLoading}>
                {t("exitGameModal.yesExit")}
              </PrimaryBtn>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ExitGameModal;
